import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from "@/main/services/reducerUtils";
import { ExcludeVariablesState } from ".";

export const useExcludeVariablesReducer = (keyReducer: string = "default") => {
	const returnSelector = useSelector((state: ApplicationState) => state.excludeVariables);
	if (keyReducer === "default") return returnSelector as IReducerWithIsolated<ExcludeVariablesState>;

	const updateState = {
		...returnSelector,
		isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA,
	};

	return updateState as IReducerWithIsolated<ExcludeVariablesState>;
};
